import axios from "axios";
import Links from "../constants/Links";

const Wallet = {
    getBalance: async (studentId) => {
        const params = studentId ? { studentId } : {};
        return axios.get(Links.wallet.balance, { params });
    },

    getSummary: async (studentId) => {
        const params = studentId ? { studentId } : {};
        return axios.get(Links.wallet.summary, { params });
    },

    getHistory: async (page = 0, size = 20, studentId) => {
        const params = { page, size };
        if (studentId) params.studentId = studentId;
        return axios.get(Links.wallet.history, { params });
    },

    fund: async (data) => {
        return axios.post(Links.wallet.fund, data);
    },

    bulkFund: async (file) => {
        const formData = new FormData();
        formData.append('file', file);
        return axios.post(Links.wallet.bulkFund, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
    },

    getBulkStatus: async (batchId) => {
        return axios.get(Links.wallet.bulkStatus + batchId);
    },

    getBulkHistory: async (page = 0, size = 20) => {
        return axios.get(Links.wallet.bulkHistory, { params: { page, size } });
    },

    checkInProgress: async () => {
        return axios.get(Links.wallet.bulkInProgress);
    },

    reverseDebit: async (data) => {
        return axios.post(Links.wallet.reverseDebit, data);
    },

    getSettings: async () => {
        return axios.get(Links.wallet.settings);
    },

    updateSettings: async (data) => {
        return axios.put(Links.wallet.settings, data);
    },

    enablePayments: async () => {
        return axios.post(Links.wallet.enablePayments);
    },

    disablePayments: async () => {
        return axios.post(Links.wallet.disablePayments);
    },

    addExemptedItem: async (feeItemTitleId) => {
        return axios.post(Links.wallet.addExemptedItem + feeItemTitleId);
    },

    removeExemptedItem: async (feeItemTitleId) => {
        return axios.delete(Links.wallet.removeExemptedItem + feeItemTitleId);
    },

    // Topup methods
    initializeTopup: async (data) => {
        return axios.post(Links.wallet.topup, data);
    },

    verifyTopupPayment: async (data) => {
        return axios.post(Links.wallet.verifyTopupPayment, data);
    },
};

export default Wallet;
